<template>
  <div class="app-title-box" :class="rootClass">
    <component :is="tag" class="app-title-box__title">{{ title }}</component>
    <app-tooltip-answer
      v-if="isTooltip"
      :tooltip="tooltip"
      class="app-title-box__tooltip"
    ></app-tooltip-answer>
    <div
      v-if="isRequired"
      class="app-title-box__helper app-title-box__helper--flex"
    >
      <span class="app-title-box__required"></span>
    </div>
    <div class="app-title-box__helper">
      <slot name="append" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTitleBox',
  components: {
    AppTooltipAnswer: () => import('@/components/ui/AppTooltipAnswer'),
  },
  props: {
    tag: {
      type: String,
      default: 'h3',
    },
    isTooltip: {
      type: Boolean,
    },
    isRequired: {
      type: Boolean,
    },
    title: {
      type: String,
      default: 'Заголовок блока',
    },
    tooltip: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    rootClass() {
      return [
        {
          'app-title-box--large': this.size === 'large',
          'app-title-box--small': this.size === 'small',
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.app-title-box {
  $this: &;

  display: flex;
  align-items: center;
  height: 16px;

  &__tooltip {
    flex-shrink: 0;
  }

  &__title {
    margin: 0;
    font-size: rem(14);
    font-weight: 300;
    line-height: 18px;
    color: $color-black;
  }

  &__helper {
    margin-left: 8px;
    line-height: initial;

    &--flex {
      display: flex;
    }
  }

  &__required {
    display: inline-block;
    width: 5px;
    height: 5px;
    vertical-align: middle;
    background-color: $color-red;
    border-radius: 50%;
  }

  &--large {
    #{$this}__title {
      font-size: rem(18);
      line-height: 22px;
    }
  }

  &--small {
    #{$this}__title {
      font-size: rem(12);
      line-height: 13px;
      color: $color-gray-8;
      letter-spacing: 0.03em;
    }
  }
}
</style>
